import { configureStore } from "@reduxjs/toolkit";
import TemplateContents from "./TemplateContents";
import QuestionInputReducer from "./QuestionInputReducer";
import ChatComponentReducer from "./ChatComponentReducer";
import FeedBackPageComponentReducer from "./FeedBackPageComponentReducer";
import AllProductSuggestionsReducer from "./AllProductSuggestionsReducer";

const store = configureStore({
    reducer: {
        templateContents: TemplateContents,
        questionInput: QuestionInputReducer,
        chatComponent: ChatComponentReducer,
        feedBackPage: FeedBackPageComponentReducer,
        allProductSuggestions: AllProductSuggestionsReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ["questionInput.fileAttachments", "questionInput.answerGenerationActiveDetails.fileAttachments"],
                ignoredActions: ["questionInput/updateFileAttachments", "questionInput/updateAnswerGenerationActiveDetails"]
            }
        })
});

export type RootState = ReturnType<typeof store.getState>;
export default store;

// Export all memoized selectors
export * from "./selectors";
